import React from 'react';
import CountUp from 'react-countup';
import { BsPlus } from "react-icons/bs";

const Counter = () => {
    return (
        <>
        <div className='flex flex-col justify-center items-center align-middle p-2 pb-4 text-white bg-slate-950 rounded-xl'>
            <div className='text-xl relative pt-2 mb-2 flex flex-row'>
            <CountUp start={0} end={710} duration={7} className="text-primary text-xl sm:text-4xl font-bold text-center"></CountUp>
            <BsPlus className='text-4xl font-bold text-orange-400' />
            </div>
            <h4 className='text-md'>Satisfied Customers</h4>
        </div>
        <div className='flex flex-col justify-center items-center align-middle p-2 pb-4 text-white bg-slate-950 rounded-xl'>
            <div className='text-xl relative pt-2 mb-2 flex flex-row'>
            <CountUp start={0} end={6} duration={7} className="text-primary text-xl sm:text-4xl font-bold text-center"></CountUp>
            <BsPlus className='text-4xl font-bold text-orange-400' />
            </div>
            <h4 className='text-md'>Projects Completed</h4>
        </div>
        <div className='flex flex-col justify-center items-center align-middle p-2 pb-4 text-white bg-slate-950 rounded-xl'>
            <div className='text-xl relative pt-2 mb-2 flex flex-row'>
            <CountUp start={0} end={100} duration={7} className="text-primary text-xl sm:text-4xl font-bold text-center"></CountUp>
            <BsPlus className='text-4xl font-bold text-orange-400' />
            </div>
            <h4 className='text-md'>Appartments</h4>
        </div>
        <div className='flex flex-col justify-center items-center align-middle p-2 pb-4 text-white bg-slate-950 rounded-xl'>
            <div className='text-xl relative pt-2 mb-2 flex flex-row'>
            <CountUp start={0} end={710} duration={7} className="text-primary text-xl sm:text-4xl font-bold text-center"></CountUp>
            <BsPlus className='text-4xl font-bold text-orange-400' />
            </div>
            <h4 className='text-md'>Satisfied Customers</h4>
        </div>
        </>
    );
}

export default Counter;
